/*
  Keeps the --minHeight css var (default `100vh` on :root) in sync with the viewport on touch devices.

  UiHandler starts with device '' and viewport.height '': writing `${''}px` would store the string "px",
  which is a valid custom property value, so the `var(--minHeight, 100vh)` fallback never applies
  and every calc() relying on it (ie. the Modal max-height) becomes invalid.
  On desktop the inline value is removed so the :root default applies.
*/
export default function syncMinHeightVar(device, viewport) {
  const style = document.documentElement.style;

  if (device === 'desktop') {
    style.removeProperty('--minHeight');
    return;
  }

  const height = viewport && viewport.height;
  if (device && typeof height === 'number' && height > 0) {
    style.setProperty('--minHeight', `${height}px`);
  }
}
